import {qtCalcMod} from './estimation-order.js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export {
  Page,
  initTippy,
  anchorMenu,
  mainSlider,
  gnavDrop,
  asideSubNav,
  header,
  commonModal,
  fixFooter,
  topBtn,
  panelRadioSelected,
  setAccordion,
  readMoreAccd,
  fileInputMod,
  checkboxAccordion,
  singleCheck,
  nextRowAccordion,
  commonValues,
  selectToggleContent,
  checkAll,
  agreeCheckScroll,
  agreeCheck,
  agreeCheckAll,
  switchContentSelect,
  switchContentRadio,
  radioSwitchAccordion,
  kamishibai,
  spVerticalRowAlignCell,
  oneClickForm,
  switchPasswordDisplay,
  switchHashBySelect,
  fixedAsideByScroll,
  bodyPaddingTop,
  fixedSideMenuByScroll
};

var commonValues = (function(){
  return {
    accordionSpeed: 300,
    fadeSpeed: 400
  }
})();

var Page = (function () {
  var mediaQueries = {
    sp: "(max-width: 668px)",
    tab: "(max-width: 980px)"
  };
  return {
    isSp: function () {
      return window.matchMedia(mediaQueries.sp).matches;
    },
    isTab: function () {
      return window.matchMedia(mediaQueries.tab).matches;
    }
  };
})();

// `data-tippy-content` が設定された要素にツールチップを適用
var initTippy = function(){
  var selector = '[data-tippy-content]';
  if (!document.querySelector(selector)) {
    return;
  }

  tippy(selector, {
    animation: 'shift-away',
    duration: [180, 120]
  });
};

//汎用アンカーリンク
var anchorMenu = function(){
  $(".js-anchor").on('click', function(){
    var target = $(this.hash);
    if (!target.length) {
      return false;
    }
    var targetPos = target.offset().top;
    if(Page.isTab()){
      //以下jQueryセレクタ、spヘッダー固定でも使用
      var headerHeight = $('.js-sp-hd-middle').length ? $('.js-sp-hd-middle').outerHeight() : 0;
      $('html,body').animate({scrollTop: targetPos - headerHeight});
    }else{
      $('html,body').animate({scrollTop: targetPos});
    }
    return false;
  });
};

// mvスライダー
var mainSlider = function(){
  var instance = null;
  var el = '.js-mv-slide';
  var $el =  $(el);
  var slideLength = $(".main-slider-item", el).length;
  var hasOneSlide = slideLength === 1;

  return{
    init: function(){
      if (!$el.length) {
        return false;
      }
      instance = new Swiper(el, {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        effect: 'slide',
        speed: 600,
        slidesPerView: 'auto',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next.js-mv-next',
          prevEl: '.swiper-button-prev.js-mv-prev',
        },
        touchEventsTarget: 'wrapper',
        on: {
          /*slideChangeTransitionEnd: textLineCut.mv*/
        }

      });
      if(hasOneSlide){
        instance.destroy();
        $('.swiper-button-next.js-mv-next, .swiper-button-prev.js-mv-prev').hide();
        $('.swiper-pagination').hide();
      }
    }
  }
};

//PCヘッダー階層ドロップメニュー
var gnavDrop = function(){

  //ドロップメニュー親階層
  $('.js-has-drop').mouseenter(function() {
    $('.js-has-drop').removeClass('child-open');

    var menuHeight = $(this).outerHeight();
    //leftの値はcssで固定設定
    $('.js-drop-nav-wrap').css({
      'top': menuHeight
    });
    $(this).addClass('child-open');

  }).mouseleave(function() {
    //大元からマウスが外れた時に、ドロップメニューの表示切替用クラス全て外す
    $(this).removeClass('child-open').find('.js-drop-side-nav').removeClass('has-area is-visible');
  });

  //ドロップメニュー子階層
  $(".js-drop-nav").menuAim({
    activate: activateMenu,
    deactivate: function(){
      return true;
    },
    exitMenu: function(){
      return true;
    }
  });
  function activateMenu(row){
    $('.js-drop-side-nav').removeClass('is-visible');
    var parentWidth = $(row).closest('.js-drop-nav').outerWidth();
    $(row).find('.js-drop-side-nav').addClass('is-visible').css({
      'left': parentWidth
    });
    //has-areaクラスは全ての子要素に一度に追加。大元からmouseleaveするまでは外さない
    $('.js-drop-side-nav').addClass('has-area');

    //親と子のボックス高さ戻す
    $(row).closest('.js-drop-nav-wrap').css({'height': 'auto'});
    $(row).find('.js-drop-side-nav').css({'height': 'auto'});

    //親と子のボックス高さ揃え
    var parentHeight = $(row).closest('.js-drop-nav-wrap').outerHeight(),
      childHeight = $(row).find('.js-drop-side-nav').outerHeight();
    var bothHeight = parentHeight > childHeight ? parentHeight : childHeight;
    $(row).closest('.js-drop-nav-wrap').outerHeight(bothHeight);
    $(row).find('.js-drop-side-nav').outerHeight(bothHeight);
  }
};

//PCトップ・商品選択サブメニュー
var asideSubNav = function(){
  $('.js-has-aside-sub').mouseenter(function(){

    // Fixedにしている子メニューを親メニューの右に配置
    var left = $(this).offset().left - $(window).scrollLeft() + $(this).outerWidth();
    var top = $(this).offset().top - $(window).scrollTop();
    $(this).find('.js-aside-sub').css({
      'left': left,
      'top': top
    }).addClass('is-open');
  }).mouseleave(function(){
    $(this).find('.js-aside-sub').removeClass('is-open');
  });
};

//spヘッダーとバーガーメニュー
var header = function(){
  var $openBtn = $('.js-sp-nav-btn'),
  $closeTrig = $('.js-side-content-close, .js-sp-side-overlay'),
  $content = $('.js-sp-side-content'),
  $overlay = $('.js-sp-side-overlay'),
  $fixedHeader = $('.js-sp-hd-middle');

  var $spLow = $('.js-sp-hd-low'),
  //以下jQueryセレクタ、アンカーリンクスクロールでも使用
  $spMiddle = $('.js-sp-hd-middle');
  var $middleBasePadding = parseInt($spMiddle.css('padding-top'));
  var scrPos = 0;
  return{
    //SPドロワーメニュー開閉
    setSpMenuEvent: function(){
      $openBtn.on("click", function() {
        $content.addClass('open');
        $overlay.fadeIn(200);
        scrPos = $(window).scrollTop();
        $('body').css({
          'top': -scrPos,
          'height': `calc(100% + ${scrPos}px)`
        }).addClass('is-fixed');
        $fixedHeader.addClass('is-body-fixed');
      });
      $closeTrig.on("click", function() {
        $content.removeClass('open').find('.js-accd-trig.is-open').trigger('click');
        $overlay.fadeOut(200, function(){
          $('body').css({
            'height': 'auto'
          }).removeClass('is-fixed');
          $fixedHeader.removeClass('is-body-fixed');
          $(window).scrollTop(scrPos);
        });
      });
    },
    //spヘッダー上部固定時のヘッダー下部padding設定
    setSpPadding: function(){
      $('.js-sp-hd-low').css({'padding-top': `${$('.hd-middle--sp').outerHeight() + $middleBasePadding}px`})
    }
  }
};

//汎用モーダル
var commonModal = function(){
  var scrPos = 0;

  //モーダル内アンカースクロール
  (function(){
    $('.js-anchor-in-modal').on('click', function(){
      var $target = $(this.hash);
      var targetPos = $target.position().top;
      var $modalWrap = $(this).closest('.theme-modal-wrap');
      var modalWrapPaddingTop = $modalWrap.css('padding-top');
      $modalWrap.closest('.theme-modal-wrap').animate({scrollTop: targetPos + parseInt(modalWrapPaddingTop)});
    });
  })();

  //カスタムデータ属性を見て対応するモーダルを開く
  $(document).on('click', '.js-modal-open', function(){
    scrPos = $(window).scrollTop();
    var modalData = $(this).data('modal'),
        $modal = $(`.js-modal[data-modal="${modalData}"]`);
    if(!$modal.length){
      return false;
    }
    if ($(this).hasClass('js-copy-link')) {
        $modal.find('.js-link').attr('href', $(this).attr('href'));
    }
    var title = $(this).data('modalTitle');
    if (title) {
        $modal.find('.js-modal-title').html(title);
    }

    $modal.fadeIn();
    $('body').css({
        'top': -scrPos,
        'height': `calc(100% + ${scrPos}px)`
      }).addClass('is-fixed');
    $('.js-sp-hd-middle').addClass('is-body-fixed');
    //モーダル内に数量計算要素がある場合、見出し左右列の行高さ揃える
    qtCalcMod.rowMatchHeight();

    if (!this.hash || !$(this.hash).length) {
      return false;
    }
    //js-modalのhrefにハッシュがある場合、それを使ってモーダル内スクロール
    var $target = $(this.hash);
    var targetPos = $target.position().top;
    var $modalWrap = $modal.closest('.theme-modal-wrap');
    var modalWrapPaddingTop = $modalWrap.css('padding-top');
    $modalWrap.closest('.theme-modal-wrap').animate({scrollTop: targetPos + parseInt(modalWrapPaddingTop)});

    return false;
  });

  $('.js-modal-open-load').on('click', function(){
      scrPos = $(window).scrollTop();
      var modalData = $(this).data('modal');
      if(!$(`.js-modal[data-modal="${modalData}"]`).length){
          return false;
      }
      if(!$(this).data('modal-url')) {
          return false;
      }
      $('.theme-modal-body-load').load($(this).data('modal-url'), function(){
          $(`.js-modal[data-modal="${modalData}"]`).fadeIn();
          $('body').css({
            'top': -scrPos,
            'height': `calc(100% + ${scrPos}px)`
          }).addClass('is-fixed');
          $('.js-sp-hd-middle').addClass('is-body-fixed');
          //モーダル内に数量計算要素がある場合、見出し左右列の行高さ揃える
          qtCalcMod.rowMatchHeight();
      });
      return false;
  });
  //閉じる
  $(document).on('click', '.js-modal-close, .js-modal', function(e){
    if($(e.target).closest('.js-modal-close').length || !$(e.target).closest('.js-modal-inner').length){
      var $target = $(this).hasClass('js-modal-close') ? $(this).closest('.js-modal') : $(this);
      $target.fadeOut(function(){
        $('body').css({
          'height': 'auto'
        }).removeClass('is-fixed');
        $('.js-sp-hd-middle').removeClass('is-body-fixed');
        $(window).scrollTop(scrPos);
        //モーダルの中にある紙芝居を初期化
        kamishibai().initialize($target.find('.js-replace-contents'));
      });
    }
  });

  //合成画像関連
  $('.js-composite-button').on('click', function () {
      const $block = $(this).closest('.js-composite');

      $block.find('.js-composite-img').attr('src', $(this).find('img').attr('src'));
      $block.find('.js-composite-button').removeClass('current');
      $(this).addClass('current');

      return false;
  });
};

//フッター最下部固定
var fixFooter = function(){
  var headerHeight = $('.header').length ? $('.header').outerHeight() : 0,
  //.js-footerはページトップボタンと、商品詳細画面下部プリント加工リンクでも使用
  footerHeight = $('.js-footer').length ? $('.js-footer').outerHeight() : 0,
  breadcrumbHeight = $('.breadcrumb').length ? $('.breadcrumb').outerHeight() : 0,
  contentTopMargin = $('.js-content-wrap').length ? $('.js-content-wrap').css('marginTop') : 0,
  //コンテンツとフッターの間の調整用余白必要なとき設定
  contentBottomMargin = 0;
  $('.js-content-wrap').css({
    'min-height': `calc(100% - (${headerHeight + breadcrumbHeight}px + ${contentTopMargin}))`,
    'padding-bottom': `${footerHeight + contentBottomMargin}px`
  });
};

//ページトップボタン
var topBtn = function() {
  var $btn = $('.js-pagetop');
  var speed = 400;
  /*
    PCレイアウトでのボタン位置を決める基準要素
  */
  var $pcBaseEl = $('.js-pc-pagetop-base');
  //SPレイアウトでのボタン位置を決める基準要素
  var $spBaseEl = $('.js-sp-pagetop-base');
  //ボタン位置固定用の値 PC/SP共通
  var baseBottomPos = 25;

  return{
    onEvt: function(){
      $btn.on('click', function(){
        this.animateTop();
      }.bind(this));
    },
    display: function(){
      $(window).scrollTop() > 100 ? $btn.stop().fadeIn() : $btn.stop().fadeOut();
      return this;
    },
    position: function(){
      if (!$btn.length || !$pcBaseEl.length || !$spBaseEl.length){
        return this;
      }
      var windowBottom = $(window).outerHeight() + $(window).scrollTop();
      if(Page.isSp()){
        /*
          SPレイアウト
          基準要素の下位置+固定値 < ウィンドウの下位置のとき基準要素に合わせて位置決め
        */
        var baseElBottom = $spBaseEl.offset().top + $spBaseEl.outerHeight();
        if(baseElBottom + baseBottomPos < windowBottom){
          //ボタンを基準要素の下位置に揃える
          $btn.css({'bottom': `${$(window).outerHeight() - $spBaseEl[0].getBoundingClientRect().bottom}px`});
        }else{
          $btn.css({'bottom': `${baseBottomPos}px`});
        }
      }else{
        /*
          PCレイアウト
          基準要素の上位置+固定値 < ウィンドウの下位置のとき基準要素に合わせて位置決め
        */
        if($pcBaseEl.offset().top + baseBottomPos < windowBottom){
          //ボタンを基準要素の上に乗るように揃える
          $btn.css({'bottom': `${$pcBaseEl.outerHeight() + ($(window).outerHeight() - $pcBaseEl[0].getBoundingClientRect().bottom)}px`});
        }else{
          $btn.css({'bottom': `${baseBottomPos}px`});
        }
      }
      return this;
    },
    animateTop: function(){
      $('body,html').animate({scrollTop: 0}, speed, 'swing');
      return this;
    }
  }
};

//パネルタイプのラジオボタンselectedクラス付け外し
var panelRadioSelected = function(){
  $(document).on('change', '.js-panel-radio', function(){
    var name = $(this).attr('name');
    $(`.js-panel-radio[name="${name}"]`).closest('.js-panel-radio-parent').removeClass('selected');
    $(this).closest('.js-panel-radio-parent').toggleClass('selected', $(this).prop('checked'));
  });
};

var setAccordion = function(trgSelector){
  $(trgSelector).closest('.js-accd-parent').find('.js-accd-target').hide();
  $(trgSelector).filter('.is-open').closest('.js-accd-parent').find('.tgl-btn').addClass('is-open');
  $(document).on('click', trgSelector, function(){
    var $parent = $(this).closest('.js-accd-parent');
    $parent.find('.js-accd-target').eq(0).stop().slideToggle(commonValues.accordionSpeed);
    //アコーディオン内に数量計算要素がある場合、見出し左右列の行高さ揃える
    qtCalcMod.rowMatchHeight();
    //イベントターゲット自体がボタンである場合とそうでない場合を考慮
    $(this).not('.tgl-btn').toggleClass('is-open');
    $parent.find('.tgl-btn').toggleClass('is-open');
  });

  //初期表示1つ目開く
  $('.js-accd-group.open-first').find(trgSelector).eq(0).trigger('click');

  //初期表示pcのみ全て開く
  if(!Page.isSp()){
    $('.js-accd-group.open-all-pc').find(trgSelector).trigger('click');
  }
};

var readMoreAccd = function(){
  var $parent = $('.js-gradaccd-parent'),
  $content = $('.js-grad-content'),
  $trigger = $('.js-readmore-trig'),
  val = {
    hideHeight: 100,
    targetHeight: 150
  }

  //SPでコンテンツ一定高さより高いならis-activeクラスつける
  function toggleActive(){
    if(Page.isSp()){
      $parent.each(function(){
        $(this).toggleClass('is-active', $(this).find($content).outerHeight() > val.targetHeight);
      });
    }else{
      $parent.removeClass('is-active');
    }
  }

  return{
    onEvt: function(){
      $trigger.on('click', function(){
        var $targetParent = $(this).closest($parent);
        if($targetParent.hasClass('is-hide')){
          var contentHeight = $targetParent.find($content).outerHeight();
          $targetParent.animate({
            height: contentHeight
          }, {
            duration: commonValues.accordionSpeed,
            complete: function(){
              $(this).height('auto');
            }
          }).removeClass('is-hide');
        }else{
          $targetParent.animate({height: val.hideHeight}, commonValues.accordionSpeed).addClass('is-hide');
        }
      });
      return this;
    },
    initial: function(){
      //初期表示
      if(Page.isSp()){
        toggleActive();
        $parent.filter('.is-active').addClass('is-hide').outerHeight(val.hideHeight);
      }
      return this;
    },
    resized: function(){
      toggleActive();
      if(Page.isSp()){
        $trigger.show();
        $parent.height('auto');
        $parent.filter('.is-active.is-hide').height(val.hideHeight);
      }else{
        $trigger.hide();
        $parent.height('auto');
      }
    }
  }
};

/*
  ファイルインプット
  fileTypesはチェクしたいフォーマットを、
  Fileオブジェクトのメディアタイプとして配列で渡す
*/
var fileInputMod = function($parentSelector, fileTypes){
  var $parent = $parentSelector;
  var $delete = $parent.find($('.js-file-input-delete'));
  var $input = $parent.find($('.js-file-input'));
  var $name = $parent.find($('.js-file-input-name'));
  var $dummy = $parent.find($('.js-file-input-dummy'));
  var $placeholder = $parent.find($('.js-file-input-placeholder'));
  var $error = $parent.find($('.js-file-input-error'));

  //fileフォーマットの確認
  function isAccept(acceptTypes, setFileType){
    if(acceptTypes === undefined) {
      return true;
    }
    return acceptTypes.some(function(el){
      if(setFileType === el){
        return true;
      };
    });
  }

  $error.hide();
  $input.on('change', function(){
    var setFiles = $(this)[0].files;
    var $targetParent = $(this).closest($parent);
    //ファイル入力されていなかったらファイル名空に
    if(!setFiles.length){
      $targetParent.find($name).text('');
      $targetParent.find($dummy).removeClass('selected');
      return false;
    }

    /*
      ファイルフォーマットあっている時だけファイル名表示、
      あっていない時はファイル名、input空でエラー表示
    */
    if(isAccept(fileTypes, setFiles[0].type)){
      $targetParent.find($name).text(setFiles[0].name);
      $targetParent.find($dummy).addClass('selected');
      $targetParent.find($error).hide();
    }else{
      $targetParent.find($error).show();
      $targetParent.find($input).val('');
    }
  });

  $delete.on('click', function(){
    const identifier = $(this).data('identifier'),
      clear = () => $(this).closest($parent).find($input).val('').trigger('change')

    if (!identifier) {
      clear();
    } else {
      $.ajax({
        url: '/api/v1/temporarily/' + identifier,
        method: 'delete'
      }).done(clear);
    }
  });

  //inputにdisabledがある場合、css用に親.theme-file-inputにdisabled属性付与
  $input.each(function(){
    if($(this).is('[disabled]')){
      $(this).closest('.theme-file-input').attr('disabled', true);
    }

    //ファイル名入力欄がない、もしくは空の場合、placeholder用要素表示
    var isEmpty = $.trim($(this).closest('.theme-file-input').find($name).html()) === '';
    if(!$(this).closest('.theme-file-input').find($name).length || isEmpty){
      $(this).closest('.theme-file-input').find($placeholder).show();
    } else {
      $(this).closest('.theme-file-input').find($dummy).addClass('selected');
    }
  });
};

//汎用チェックボックスアコーディオン
var checkboxAccordion = () => {
  var $check = $('.js-check-accd-check');
  var $parent = $('.js-check-accd-box');
  var $body = $('.js-check-accd-body');

  $check.not(':checked').closest($parent).find($body).hide();

  $check.on('change.checkboxAccordion', function(){
    var $currentParent = $(this).closest($parent);
    if($(this).prop('checked')){
      $currentParent.find($body).first().stop().slideDown(commonValues.accordionSpeed, function(){
        $(this).height('auto');
      });
      $currentParent.addClass('checked');
    }else{
      $currentParent.find($body).first().stop().slideUp(commonValues.accordionSpeed);
      $currentParent.removeClass('checked');
    }
  }).trigger('change.checkboxAccordion');
};

//一つしか選択させたくないチェックボックス
var singleCheck = function(){
  var $parent = $('.js-single-check-group');
  $parent.find('input[type="checkbox"]').on('change', function(){
    var parentData = $(this).closest($parent).data('single-check');
    $(this).closest($parent).find(`input[type="checkbox"][data-single-check=${parentData}]`).not($(this)).filter(':checked').prop('checked', false).trigger('change.checkboxAccordion');
  });
};

/*
  テーブル内アコーディオン
*/
var nextRowAccordion = function(){

  /*
    初期表示 対象コンテンツとそのコンテンツがあるセルを非表示
    sp用ボタンにis-openクラスがついていれば、コンテンツとセルを表示
  */
  $('.js-table-accd-target').hide();
  $('.js-table-accd-trig').filter('.is-open').closest('td').find('.js-table-accd-target').show();

  $(document).on('click', '.js-table-accd-trig', function(){
    var $target = $(this).closest('tr').next('tr').find('.js-table-accd-target');

    //対象の親のセルに開閉時個別のタイミングで、スタイル用のis-openクラス付け外し
    if($(this).hasClass('is-open')){
      $target.stop().slideUp(commonValues.accordionSpeed, function(){
        $(this).closest('td').removeClass('is-open');
      });
    }else{
      $target.closest('td').addClass('is-open');
      $target.stop().slideDown(commonValues.accordionSpeed);
    }
    //ボタンとアイコンにis-openクラス付け外し
    $(this).toggleClass('is-open').find('.tgl-btn').toggleClass('is-open');
  });

};

//プルダウンの選択によってコンテンツのトグルを行う
var selectToggleContent = function(){
  var $parent = $('.js-select-toggle-content');
  var $select = $parent.find('.js-select');
  var $content = $parent.find('.js-content');

  $select.on('change', function(){
    $(this).closest($parent).find($content).toggle(!!$('option:selected', this).data('toggle-content'));
  }).trigger('change');
}

var checkAll = function(){
  var $parent = $('.js-check-all-content');
  var $checkAll = $('.js-check-all');
  var $checkSingle = $('.js-check-single');
  var $actionTrig = $('.js-action-trig');

  function activeActionTrig($checkElm){
    var notChecked = !$checkElm.closest($parent).find($checkSingle).filter(':checked').length;
    $checkElm.closest($parent).find($actionTrig).attr('disabled', notChecked);
  }

  $actionTrig.on('click', function(){
    if($(this).is('[disabled]')){
      return false;
    }
  })

  $checkAll.on('change', function(){
    $(this).closest($parent).find($checkSingle).prop('checked', $(this).prop('checked'));
    activeActionTrig($(this));
  });

  $checkSingle.on('change', function(){
    var $checkElm = $(this).closest($parent).find($checkSingle);
    var isCheckAll = $checkElm.length === $checkElm.filter(':checked').length;
    $(this).closest($parent).find($checkAll).prop('checked', isCheckAll);
    activeActionTrig($(this));
  });

  $checkAll.trigger('change');
  $checkSingle.trigger('change');
}

var agreeCheckScroll = function(){
  var $scrollbox = $('.js-agree-check-scrollbox');
  var $check = $('.js-agree-check');

  $scrollbox.on('scroll', function(){
    if (this.scrollHeight - this.scrollTop - this.clientHeight < 1) {
      $check.attr('disabled', false);
    }
  }).trigger('change');
}

var agreeCheck = function(){
  var $check = $('.js-agree-check');
  var $submit = $('.js-agree-submit');

  $check.on('change', function(){
    $(this).closest('form').find($submit).attr('disabled', !$(this).prop('checked'));
  }).trigger('change');
}

var agreeCheckAll = function(){
  var $check = $('.js-agree-check');
  var $submit = $('.js-agree-submit-all');
  var $flag = true;

  $check.on('change', function(){
    $flag = $('.agree-check-1').prop('checked') && $('.agree-check-2').prop('checked') ? false : true;
    $(this).closest('form').find($submit).prop('disabled', $flag);
  }).trigger('change');
}

// select選択によるコンテンツ切り替え
var switchContentSelect = () => {
  var $select = $('.js-switch-content-select');
  var $parent = $('.js-switch-content-select-parent');
  var $content = $('.js-switch-content-select-target');

  $content.hide();

  $select.on('change', function(){
    var $targetParent = $(this).closest($parent);
    var $targetContent = $targetParent.find($content);
    var data = $(this).find('option:selected').data('content');

    var speed = commonValues.fadeSpeed/2;
    var $showContent = $targetContent.filter(`[data-content="${data}"]`);
    var $hideContent = $targetContent.not(`[data-content="${data}"]`);
    if($hideContent.length){
      $hideContent.stop().fadeOut(speed, function(){
        $showContent.stop().fadeIn(speed);
      });
    }else{
      $showContent.stop().fadeIn(speed);
    }
  }).trigger('change');
};

// ラジオ選択によるコンテンツ切り替え
var switchContentRadio = ($radioParent, $contenParent, $target) => {
  var $radio = $radioParent.find('input[type="radio"]');
  var $parent = $contenParent;
  var $content = $target;

  $content.hide();

  $radio.on('change', function(){
    if(!$(this).prop('checked')){
      return false;
    }
    var $targetParent = $(this).closest($parent);
    var $targetContent = $targetParent.find($content);
    var data = $(this).filter(':checked').data('content');
    var speed = commonValues.fadeSpeed/2;
    var $showContent = $targetContent.filter(`[data-content="${data}"]`);
    var $hideContent = $targetContent.not(`[data-content="${data}"]`);
    if($hideContent.length){
      $hideContent.stop().fadeOut(speed, function(){
        $showContent.stop().fadeIn(speed);
      });
    }else{
      $showContent.stop().fadeIn(speed);
    }
  }).trigger('change');
};

// ラジオ選択によるスライドアニメーションのコンテンツ切り替え
var radioSwitchAccordion = () => {
  var $trg = $('.js-radio-switch-accd-trg-parent').find('input[type="radio"]');
  var $parent = $('.js-radio-switch-accd-parent');
  var $content = $('.js-radio-switch-accd-body');
  var $tableElm = $('.js-radio-switch-accd-table-elm');

  $trg.on('change', function(){
    var $targetParent = $(this).closest($parent);
    var $targetContent = $targetParent.find($content);
    var $targetTableElm = $targetParent.find($tableElm);
    var data = $(this).filter(':checked').data('content');
    var speed = commonValues.accordionSpeed;

    $targetContent.not(`[data-content="${data}"]`).stop().slideUp(speed, function(){
      $targetTableElm.not(`[data-content="${data}"]`).removeClass('is-show');
    });
    $targetTableElm.filter(`[data-content="${data}"]`).addClass('is-show');
    $targetContent.filter(`[data-content="${data}"]`).stop().slideDown(speed, function(){
      $(this).css({'height': 'auto'});
    });

  }).filter(':checked').trigger('change');
};

//コンテンツを表示非表示で一方通行に差し替える紙芝居機能
var kamishibai = function(){
  var $parent = $('.js-replace-contents');
  var $replaceBtn = $('.js-replace-btn');
  return{
    initialize: function($target){
      $target.each(function(){
        $(this).find('.replaced-content').eq(0).addClass('current').show();
        $(this).find('.replaced-content').not(':eq(0)').hide().removeClass('current');
      });
      return this;
    },
    bindClick: function(){
      $replaceBtn.on('click', function(){
        var $contents = $(this).closest($parent).find('.replaced-content');
        var current = $contents.index($contents.filter(':visible'));
        if($contents.length - 1 === current){
          return false;
        }
        $contents.eq(current).removeClass('current').fadeOut(commonValues.fadeSpeed);
        $contents.eq(current+1).addClass('current').fadeIn(commonValues.fadeSpeed);
      });
    }
  }
};

//sp時に行が縦のテーブルの横行揃え
var spVerticalRowAlignCell = function(){
  var $table = $('.js-sp-vertical-row-align-cell');

  if(!Page.isSp()){
    $table.each(function(){
      $(this).find('th, td').css({
        'height': 'auto'
      })
    });
    return false;
  }

  $table.each(function(){
    $(this).find('th, td').css({
      'height': 'auto'
    })
    var heightArray = [];
    $(this).find('tr').each(function(){
      if(!heightArray.length){
        $(this).find('th, td').each(function(){
          heightArray.push($(this).outerHeight());
        })
      }else{
        $(this).find('th, td').each(function(i){
          heightArray[i] = Math.max(heightArray[i], $(this).outerHeight());
        })
      }
    });
    $(this).find('tr').each(function(){
      $(this).find('th, td').each(function(i){
        $(this).outerHeight(heightArray[i])
      })
    });
  });
}

var oneClickForm = function(){
  $('.js-one-click-form').on('submit', function () {
    $(this).find(':submit').prop('disabled', true);
  });
}

// inputのパスワードの表示非表示
var switchPasswordDisplay = function () {
  $('.js-switch-password-display').on('change', function () {
    var $field = $(this).closest('.switch-password-display-wrap').find('.switch-password-display-field');
    if($(this).prop('checked')){
      $field.attr('type', 'text')
    }else{
      $field.attr('type', 'password')
    }

  })
}

var switchHashBySelect = function(){
  var $parent = $('.js-switch-hash-by-select');
  var $select = $parent.find('select');
  $select.on('change', function(){
      var hash = $(this).find('option:selected').data('hash-for-link');
      if(hash === '' || hash === undefined){
          $(this).closest($parent).find('.target-link').attr('href', '');
      }else{
          $(this).closest($parent).find('.target-link').attr('href', hash);
      }
  }).trigger('change');
}

/*
  サイドエリア 親要素内でのスクロール追従
*/
var fixedAsideByScroll = function(){
  var $content = $('.js-fixed-aside');
  var $fixedHead = $('.js-sp-hd-middle');
  var $fixedPcHead = $('.js-pc-header-content');
  var parentSelector = '.js-fixed-aside-parent';

  return{
    positioning: function(){
      if(!$content.length){
        return false;
      }
      $content.each(function(){
        // 固定ヘッダーの高さを考慮
        var adjustVal = Page.isTab() ? $fixedHead.outerHeight() : $fixedPcHead.outerHeight();
        var parentTop = $(this).closest(parentSelector).offset().top - adjustVal;
        var scrollTop = $(window).scrollTop();
        var parentBottomPos = $(this).closest(parentSelector).offset().top + $(this).closest(parentSelector).outerHeight() - adjustVal;
        var contentBottom = scrollTop + $(this).outerHeight();

        if(Page.isSp() || parentTop > scrollTop){
          /*
            SP時 or scrollTopがサイドエリアまで到達していないとき
            通常位置
          */
          $(this).css({
            'width': 'auto',
            'left': 'auto',
            'top': 'auto'
          }).removeClass('is-fixed is-fit-bottom');
        }else if(contentBottom > parentBottomPos){
          /*
            サイドエリア中身の下のスクロール位置が親要素の下位置より大きいとき
            親要素内で下寄せ
          */
          $(this).closest(parentSelector).css({
            'minHeight': $(this).outerHeight()
          })
          $(this).css({
            'width': '100%',
            'left': 'auto',
            'top': 'auto'
          }).addClass('is-fit-bottom').removeClass('is-fixed');
        }else{
          /*
            scrollTopがサイドエリアまで到達後と、
            サイドエリア中身の下のスクロール位置が親要素の下位置より小さい
            fixed
          */
          $(this).closest(parentSelector).css({
            'minHeight': $(this).outerHeight()
          })
          var width = $(this).closest(parentSelector).outerWidth();
          var left = $(this).closest(parentSelector).offset().left;
          var top = Page.isTab() ? $fixedHead.outerHeight() : $fixedPcHead.outerHeight() ;
          $(this).css({
            'width': width,
            'left': left,
            'top': top
          }).addClass('is-fixed').removeClass('is-fit-bottom');
        }

        /*
            スクロール追従して下の方が見切れないように、
            高さが画面の高さより長くならないようにする
        */
        if (!Page.isSp()) {
          $content.css({
            'max-height': `calc(100vh - ${Page.isTab() ? $fixedHead.outerHeight() : $fixedPcHead.outerHeight()}px)`,
            'overflow-y': 'auto'
          })
        } else {
            $content.css({
            'max-height': 'none',
            'overflow-y': 'visible'
          })
        }
      });
    }
  }
};

//PCヘッダー固定分のbody要素padding設定
var bodyPaddingTop = function() {
  var $header = $('.js-pc-header-content');
  var $body = $('body');

  return{
    set: () => {
      const height = $header.outerHeight();
      if (!Page.isTab()) {
        $body.css({
          'padding-top': height
        });
      } else {
        $body.css({
        'padding-top': 0
        });
      }
      return this;
    }
  }
};

/*
  サイドメニューのスクロール追従
*/
var fixedSideMenuByScroll = function(){
    var $fixedPcHead = $('.js-pc-header-content');
    var $content = $('.js-side-menu-inner');
    var parentSelector = '.js-side-menu-parent';

    return{
      positioning: function(){
        if(!$content.length){
          return false;
        }

        // 固定ヘッダーの高さを考慮
        var adjustVal = Page.isTab() ? 0 : $fixedPcHead.outerHeight();
        var parentTop = $($content).closest(parentSelector).offset().top - adjustVal;
        var scrollTop = $(window).scrollTop();
        var parentBottomPos = $($content).closest(parentSelector).offset().top + $($content).closest(parentSelector).outerHeight() - adjustVal;
        var contentBottom = scrollTop + $($content).outerHeight();

        if(Page.isSp() || parentTop > scrollTop){
          /*
            SP時 or scrollTopがサイドエリアまで到達していないとき
            通常位置
          */
          $($content).css({
            'width': 'auto',
            'left': 'auto',
            'top': 'auto'
          }).removeClass('is-fixed is-fit-bottom');
        }else if(contentBottom > parentBottomPos){
          /*
            サイドエリア中身の下のスクロール位置が親要素の下位置より大きいとき
            親要素内で下寄せ
          */
          $($content).closest(parentSelector).css({
            'minHeight': $($content).outerHeight()
          })
          $($content).css({
            'width': '100%',
            'left': 'auto',
            'top': 'auto'
          }).addClass('is-fit-bottom').removeClass('is-fixed');
        }else{
          /*
            scrollTopがサイドエリアまで到達後と、
            サイドエリア中身の下のスクロール位置が親要素の下位置より小さい
            fixed
          */
          $($content).closest(parentSelector).css({
            'minHeight': $($content).outerHeight()
          })
          var width = $($content).closest(parentSelector).outerWidth();
          var left = $($content).closest(parentSelector).offset().left;
          var top = Page.isTab() ? $fixedHead.outerHeight() : $fixedPcHead.outerHeight() ;
          $($content).css({
            'width': width,
            'left': left,
            'top': top
          }).addClass('is-fixed').removeClass('is-fit-bottom');
        }

        /*
            スクロール追従して下の方が見切れないように、
            高さが画面の高さより長くならないようにする
        */
        if (!Page.isSp()) {
          $content.css({
            'max-height': `calc(100vh - ${Page.isTab() ? 0 : $fixedPcHead.outerHeight()}px)`,
            'overflow-y': 'auto',
            'overflow-x': 'visible'
          })
        } else {
            $content.css({
            'max-height': 'none',
            'overflow-y': 'visible'
          })
        }
      }
    }
  };
